import { createRoot } from "react-dom/client";
import "./app.css";
// page and dialog modules register themselves
import "./pages/fleet";
import "./pages/workload";
import "./pages/ops";
import "./pages/account";
import "./pages/clusters";
import App from "./App";

createRoot(document.getElementById("root")!).render(<App />);
